import { RefObject, useEffect, useState } from 'react';

export const useOnClickAway = (ref: RefObject<HTMLElement>) => {
	const [clickedOnElement, setClickedOnElement] = useState(false);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			setClickedOnElement(
				Boolean(ref?.current?.contains(event?.target as HTMLElement))
			);
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return !clickedOnElement;
};
